export default function EmailValidator() {
    'ngInject';
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, elem, attrs, ngModelCtrl) {
            ngModelCtrl.$parsers.unshift(validator);

            function validator(viewValue) {
                const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

                const isValid = pattern.test(viewValue);
                ngModelCtrl.$setValidity('pattern', isValid);

                return viewValue;
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/ktEmailValidator.js